module.exports = __webpack_public_path__ + "img/110-G.de37cd47.png";